<template>
  <AuthForm
    v-model="formData"
    title="Reset password"
    description="Enter your email address to reset your password"
    :rules="rules"
    @submit="handleSubmit"
  >
    <div class="form-row mb-20px">
      <ElFormItem prop="email" class="full-width">
        <AppInput
          v-model="formData.email"
          label="Email"
          placeholder="Enter email address"
          validate-event
          type="email"
          :required="true"
        />
      </ElFormItem>
    </div>

    <template #footer>
      <div class="d--f jc--sb full-width mt-20px">
        <div>
          Remember your password? <router-link :to="{ name: 'login' }" class="router-link-plain">Sign in</router-link>
        </div>

        <div>New here? <router-link :to="{ name: 'register' }" class="router-link-plain">Sign up</router-link></div>
      </div>
    </template>
  </AuthForm>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElFormItem } from "element-plus";
import { AppInput } from "@/components/ui";

import AuthApi from "@/api/auth";
import AuthForm from "@/views/Auth/components/AuthForm.vue";
import { showToast } from "@/utilities/toast";

const router = useRouter();
const isLoading = ref(false);

const formData = reactive({
  email: "",
});

const rules = {
  email: [
    { required: true, message: "Please enter an email address", trigger: "blur" },
    { type: "email", message: "Please enter a valid email address", trigger: "blur" },
  ],
};

const handleSubmit = async () => {
  isLoading.value = true;

  try {
    await AuthApi.requestPasswordReset(formData.email);
    showToast("Password reset instructions have been sent to your email address. Please check your inbox.", {
      type: "success",
    });

    setTimeout(() => {
      router.push({ name: "login" });
    }, 3000);
  } catch (err) {
    showToast(err.response?.data?.error || "Failed to send password reset instructions. Please try again.", {
      type: "error",
    });
  } finally {
    isLoading.value = false;
  }
};
</script>
